<script>
    import { onMount } from "svelte";

    export let visible;
    $: notice = "Czerpiemy ze źródła...";

    onMount(() => {
        setTimeout(() => {
            notice = "Jeszcze kilka chwil...";
            setTimeout(() => {
                notice = "To trwa dłużej niż zwykle...";
            }, 3000);
        }, 3000);
    });
</script>

{#if visible}
    <loader>
        <div class="lds-ring">
            <div />
            <div />
            <div />
            <div />
        </div>
        <p>{notice}</p>
    </loader>
{/if}

<style type="text/scss">
    loader {
        position: fixed;
        background: #181a1b;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 1000;

        p {
            margin-top: 1rem;
            color: #c2ae8d;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
        }

        .lds-ring {
            display: inline-block;
            position: relative;
            width: 80px;
            height: 80px;

            div {
                box-sizing: border-box;
                display: block;
                position: absolute;
                width: 64px;
                height: 64px;
                margin: 8px;
                border: 8px solid #c2ae8d;
                border-radius: 50%;
                animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
                border-color: #c2ae8d transparent transparent transparent;

                &:nth-child(1) {
                    animation-delay: -0.45s;
                }

                &:nth-child(2) {
                    animation-delay: -0.3s;
                }

                &:nth-child(3) {
                    animation-delay: -0.15s;
                }
            }
        }
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>
